export default __webpack_public_path__ + "static/media/laundry2-after-2048w.b49d42c4.avif";